import { BaseConnectionService } from "./baseConnectionService";
import { ReferenceVersionConnection } from "../../types/referenceVersion";

class ReferenceVersionConnectionService extends BaseConnectionService<ReferenceVersionConnection> {
  constructor() {
    super("referenceVersion");
  }
}

export const referenceVersionConnectionService =
  new ReferenceVersionConnectionService();
